






// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
// import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
// import { db } from '../../firebase/firebaseConfig'; 
// import './Header.css';

// // Replace with your Google Maps API key
// const GOOGLE_MAPS_API_KEY = 'AIzaSyA5ReIwel6soo1uIWWRvAIdIubZQKnbjfc';

// const Header = () => {
//   const navigate = useNavigate();
//   const location = useLocation(); // Add this to get current route
//   const auth = getAuth();
  
//   // State management
//   const [isLocationDropdownOpen, setIsLocationDropdownOpen] = useState(false);
//   const [isCategoriesDropdownOpen, setIsCategoriesDropdownOpen] = useState(false);
//   const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
//   const [currentLocation, setCurrentLocation] = useState('Select Location');
//   const [fullAddress, setFullAddress] = useState(null);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [cartCount, setCartCount] = useState(0);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [isLocating, setIsLocating] = useState(false);
//   const [locationError, setLocationError] = useState('');
//   const [activeMobileTab, setActiveMobileTab] = useState('home');
//   const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isAuthLoading, setIsAuthLoading] = useState(true); // Add loading state for auth
//   const [userData, setUserData] = useState(null);
//   const [categories, setCategories] = useState([]);
//   const [isLoadingCategories, setIsLoadingCategories] = useState(true);
//   const [showSearchResults, setShowSearchResults] = useState(false);
//   const [searchResults, setSearchResults] = useState([]);
//   const [noResultsFound, setNoResultsFound] = useState(false);
  
//   // Refs for handling events
//   const categoriesRef = useRef(null);
//   const dropdownRef = useRef(null);
//   const locationRef = useRef(null);
//   const profileRef = useRef(null);
//   const mobileProfileDropdownRef = useRef(null);
//   const searchResultsRef = useRef(null);
//   const mobileNavProfileRef = useRef(null);
//   const initialAuthCheckRef = useRef(false); // Ref to track initial auth check

//   // Check if we're in mobile responsive mode
//   const isMobile = windowWidth <= 1142;

//   const predefinedLocations = [
//     'Bengaluru, Karnataka',
//     'Mumbai, Maharashtra', 
//     'Delhi, NCR',
//     'Chennai, Tamil Nadu',
//     'Hyderabad, Telangana',
//     'Pune, Maharashtra',
//     'Kolkata, West Bengal'
//   ];

//   // Add CSS styles for improving touch interactions
//   useEffect(() => {
//     const style = document.createElement('style');
//     style.innerHTML = `
//       .mobile-nav-item.profile {
//         -webkit-tap-highlight-color: transparent;
//         touch-action: manipulation;
//         cursor: pointer;
//         position: relative;
//       }
//       .mobile-nav-item.profile * {
//         pointer-events: none;
//       }
//       .profile-content-wrapper {
//         width: 100%;
//         height: 100%;
//         display: flex;
//         flex-direction: column;
//         align-items: center;
//         justify-content: center;
//       }
//       .mobile-profile-dropdown {
//         z-index: 1000;
//       }
//       .profile-overlay {
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         z-index: 1;
//       }
//       .mobile-search-overlay {
//         position: fixed;
//         top: 0;
//         left: 0;
//         right: 0;
//         bottom: 0;
//         background-color: #fff;
//         z-index: 9999;
//         display: flex;
//         flex-direction: column;
//         animation: slideInFromBottom 0.2s ease-out;
//       }
//       @keyframes slideInFromBottom {
//         0% {
//           transform: translateY(20px);
//           opacity: 0;
//         }
//         100% {
//           transform: translateY(0);
//           opacity: 1;
//         }
//       }
//       @keyframes slideOutToBottom {
//         0% {
//           transform: translateY(0);
//           opacity: 1;
//         }
//         100% {
//           transform: translateY(20px);
//           opacity: 0;
//         }
//       }
//       .mobile-search-overlay.closing {
//         animation: slideOutToBottom 0.2s ease-out;
//         animation-fill-mode: forwards;
//       }
//       /* Updated mobile search form styles without back button */
//       .mobile-search-form {
//         display: flex;
//         align-items: center;
//         padding: 12px 16px;
//         background-color: #f5f5f5;
//         border-bottom: 1px solid #e0e0e0;
//       }
//       .mobile-search-input {
//         flex: 1;
//         height: 42px;
//         padding: 8px 12px;
//         border: 1px solid #e0e0e0;
//         border-radius: 8px;
//         font-size: 16px;
//         background-color: #fff;
//       }
//       .mobile-search-submit {
//         background: none;
//         border: none;
//         padding: 8px;
//         margin-left: 8px;
//         color: #333;
//         cursor: pointer;
//       }
//       /* Add a simple spinner for loading states */
//       .auth-spinner {
//         width: 20px;
//         height: 20px;
//         border: 2px solid rgba(0, 0, 0, 0.1);
//         border-top-color: #333;
//         border-radius: 50%;
//         animation: spin 0.8s linear infinite;
//         margin-right: 8px;
//         display: inline-block;
//       }
//       @keyframes spin {
//         to {
//           transform: rotate(360deg);
//         }
//       }
//     `;
//     document.head.appendChild(style);

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   // Check auth state using Firebase Auth - UPDATED to handle loading state and ensure redirection
//   useEffect(() => {
//     setIsAuthLoading(true); // Start with loading state
    
//     // Try to get cached auth data from localStorage
//     try {
//       const cachedAuthData = localStorage.getItem('userData');
//       const authToken = localStorage.getItem('authToken');
      
//       if (cachedAuthData && authToken) {
//         try {
//           const parsedData = JSON.parse(cachedAuthData);
//           // Temporarily set user data while waiting for Firebase
//           setUserData(parsedData);
//           setIsLoggedIn(true);
          
//           // If we're on the login page, redirect to profile
//           if (location.pathname.includes('/login')) {
//             navigate('/profile');
//           }
//         } catch (parseError) {
//           console.error("Error parsing cached auth data:", parseError);
//           localStorage.removeItem('userData');
//           localStorage.removeItem('authToken');
//         }
//       }
//     } catch (error) {
//       console.error("Error accessing localStorage cache:", error);
//     }
    
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         // Get user data from Firestore
//         const fetchUserData = async () => {
//           try {
//             const userDocRef = query(
//               collection(db, 'users'),
//               where('uid', '==', user.uid)
//             );
//             const userSnapshot = await getDocs(userDocRef);
            
//             if (!userSnapshot.empty) {
//               const userData = userSnapshot.docs[0].data();
//               const userDataWithDefaults = { 
//                 uid: user.uid,
//                 name: userData.name || user.displayName || 'User',
//                 email: userData.email || user.email,
//                 phone: userData.phone || '',
//                 ...userData
//               };
              
//               setUserData(userDataWithDefaults);
              
//               // Store in localStorage for persistence
//               try {
//                 localStorage.setItem('userData', JSON.stringify(userDataWithDefaults));
//                 localStorage.setItem('authToken', 'true'); // Simple presence flag
//               } catch (error) {
//                 console.error("Error saving to localStorage:", error);
//               }
//             } else {
//               const basicUserData = {
//                 uid: user.uid,
//                 name: user.displayName || 'User',
//                 email: user.email
//               };
              
//               setUserData(basicUserData);
              
//               // Store in localStorage for persistence
//               try {
//                 localStorage.setItem('userData', JSON.stringify(basicUserData));
//                 localStorage.setItem('authToken', 'true');
//               } catch (error) {
//                 console.error("Error saving to localStorage:", error);
//               }
//             }
            
//             setIsLoggedIn(true);
            
//             // IMPORTANT: If we're on the login page, immediately redirect to profile
//             if (location.pathname.includes('/login')) {
//               navigate('/profile');
//             }
//           } catch (error) {
//             console.error("Error fetching user data:", error);
//             const fallbackData = {
//               uid: user.uid,
//               name: user.displayName || 'User',
//               email: user.email
//             };
            
//             setUserData(fallbackData);
//             setIsLoggedIn(true);
            
//             try {
//               localStorage.setItem('userData', JSON.stringify(fallbackData));
//               localStorage.setItem('authToken', 'true');
//             } catch (storageError) {
//               console.error("Error saving to localStorage:", storageError);
//             }
            
//             // Even with errors, if authenticated, redirect from login page
//             if (location.pathname.includes('/login')) {
//               navigate('/profile');
//             }
//           } finally {
//             setIsAuthLoading(false); // Auth loading complete
//             initialAuthCheckRef.current = true;
//           }
//         };
        
//         fetchUserData();
//       } else {
//         setIsLoggedIn(false);
//         setUserData(null);
        
//         // Clear localStorage data when logged out
//         try {
//           localStorage.removeItem('userData');
//           localStorage.removeItem('authToken');
//         } catch (error) {
//           console.error("Error accessing localStorage:", error);
//         }
        
//         setIsAuthLoading(false); // Auth loading complete
//         initialAuthCheckRef.current = true;
        
//         // Only redirect to login if not in the process of logging in
//         // This prevents redirecting during page refresh when auth is still initializing
//         if (initialAuthCheckRef.current && 
//             !location.pathname.includes('/login') && 
//             !location.pathname.includes('/register') &&
//             (location.pathname.includes('/profile') || 
//              location.pathname.includes('/orders') || 
//              location.pathname.includes('/wishlist'))) {
//           navigate('/login');
//         }
//       }
//     });
    
//     return () => unsubscribe();
//   }, [auth, navigate, location.pathname]);

//   // Listen for login/logout events
//   useEffect(() => {
//     const handleLoginEvent = () => {
//       // Auth state will handle this, but we can also force a data refresh
//       const cachedAuthData = localStorage.getItem('userData');
//       if (cachedAuthData) {
//         try {
//           const parsedData = JSON.parse(cachedAuthData);
//           setUserData(parsedData);
//           setIsLoggedIn(true);
//         } catch (error) {
//           console.error("Error parsing userData from event:", error);
//         }
//       }
//     };
    
//     const handleLogoutEvent = () => {
//       setIsProfileDropdownOpen(false);
//       setIsLoggedIn(false);
//       setUserData(null);
//     };
    
//     window.addEventListener('userLoggedIn', handleLoginEvent);
//     window.addEventListener('userLoggedOut', handleLogoutEvent);
    
//     return () => {
//       window.removeEventListener('userLoggedIn', handleLoginEvent);
//       window.removeEventListener('userLoggedOut', handleLogoutEvent);
//     };
//   }, []);

//   // Set active tab based on current path
//   useEffect(() => {
//     const currentPath = location.pathname;
    
//     if (currentPath === '/' || currentPath === '/home') {
//       setActiveMobileTab('home');
//     } else if (currentPath.includes('/products')) {
//       setActiveMobileTab('categories');
//     } else if (currentPath.includes('/cart')) {
//       setActiveMobileTab('cart');
//     } else if (currentPath.includes('/profile') || 
//                currentPath.includes('/login') || 
//                currentPath.includes('/orders') ||
//                currentPath.includes('/wishlist')) {
//       setActiveMobileTab('profile');
//     } else {
//       setActiveMobileTab('home');
//     }
//   }, [location]);

//   // Fetch categories from Firestore
//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         setIsLoadingCategories(true);
//         // Get only active categories and sort them
//         const categoriesQuery = query(
//           collection(db, 'categories'),
//           where('active', '==', true),
//           orderBy('name')
//         );
//         const categoriesSnapshot = await getDocs(categoriesQuery);
        
//         if (!categoriesSnapshot.empty) {
//           const categoriesData = categoriesSnapshot.docs.map(doc => doc.data().name);
//           setCategories(categoriesData);
//         } else {
//           console.log('No categories found in Firestore');
//           setCategories([]);
//         }
//       } catch (error) {
//         console.error('Error fetching categories from Firestore:', error);
//         // Fallback to default categories if there's an error
//         setCategories([
//           'Microcontrollers',
//           'Single Board Computers',
//           'Sensors',
//           'Actuators',
//           'Motor Controllers',
//           'Power Components',
//           'Communication Modules',
//           'Interface Components',
//           'Mechanical Components',
//           'Tools and Accessories'
//         ]);
//       } finally {
//         setIsLoadingCategories(false);
//       }
//     };

//     fetchCategories();
//   }, []);

//   // Add resize handler
//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;
//       setWindowWidth(width);
      
//       // Add padding to body when mobile nav is shown
//       if (width >= 340 && width <= 1142) {
//         document.body.style.paddingBottom = '60px';
//         document.documentElement.classList.add('mobile-viewport');
//       } else {
//         document.body.style.paddingBottom = '0';
//         document.documentElement.classList.remove('mobile-viewport');
//       }
//     };

//     // Set initial values immediately
//     handleResize();
    
//     // Add event listener
//     window.addEventListener('resize', handleResize);
    
//     return () => {
//       window.removeEventListener('resize', handleResize);
//       document.body.style.paddingBottom = '0';
//       document.documentElement.classList.remove('mobile-viewport');
//     };
//   }, []);

//   // Add touch event handler specifically for mobile profile button
//   useEffect(() => {
//     const handleProfileButtonInteraction = (e) => {
//       if (isMobile && isLoggedIn) {
//         e.preventDefault();
//         navigate('/profile');
//         window.scrollTo(0, 0); // Add scroll to top here
//         setTimeout(() => {
//           setIsProfileDropdownOpen(true);
//         }, 100);
//       }
//     };

//     // Add event listener to the profile button
//     const profileButton = mobileNavProfileRef.current;
//     if (profileButton) {
//       profileButton.addEventListener('touchstart', handleProfileButtonInteraction, { passive: false });
//     }

//     return () => {
//       if (profileButton) {
//         profileButton.removeEventListener('touchstart', handleProfileButtonInteraction);
//       }
//     };
//   }, [isMobile, isLoggedIn, navigate, mobileNavProfileRef]);
  
//   // Close mobile search with animation
//   const closeMobileSearch = () => {
//     const overlay = document.getElementById('mobile-search-overlay');
//     if (overlay) {
//       overlay.classList.add('closing');
//       setTimeout(() => {
//         setIsMobileSearchOpen(false);
//       }, 200); // Match animation duration
//     } else {
//       setIsMobileSearchOpen(false);
//     }
//   };

//   // Handle browser back button for mobile search
//   useEffect(() => {
//     const handlePopState = (event) => {
//       // If the search overlay is open, close it when back button is pressed
//       if (isMobileSearchOpen) {
//         closeMobileSearch();
//       }
//     };

//     // Add event listener for the back button
//     window.addEventListener('popstate', handlePopState);
    
//     // Clean up the event listener when component unmounts
//     return () => {
//       window.removeEventListener('popstate', handlePopState);
//     };
//   }, [isMobileSearchOpen]);

//   // Add scroll handler to close mobile search when scrolling back
//   useEffect(() => {
//     let lastScrollY = window.scrollY;
//     let touchStartY = 0;
//     let scrollThreshold = 20; // minimum scroll distance to trigger close
    
//     const handleScroll = () => {
//       if (!isMobileSearchOpen) return;
      
//       const currentScrollY = window.scrollY;
//       const scrollDifference = currentScrollY - lastScrollY;
      
//       // If scrolling up (negative difference) by more than threshold, close the search
//       if (scrollDifference < -scrollThreshold) {
//         closeMobileSearch();
//       }
      
//       lastScrollY = currentScrollY;
//     };
    
//     const handleTouchStart = (e) => {
//       touchStartY = e.touches[0].clientY;
//     };
    
//     const handleTouchMove = (e) => {
//       if (!isMobileSearchOpen) return;
      
//       const currentY = e.touches[0].clientY;
//       const diff = currentY - touchStartY;
      
//       // If swiping down by more than threshold, close the search
//       if (diff > scrollThreshold * 2) {
//         closeMobileSearch();
//       }
//     };
    
//     if (isMobileSearchOpen) {
//       // Reset the last scroll position when opening the search
//       lastScrollY = window.scrollY;
      
//       // Add scroll event listener
//       window.addEventListener('scroll', handleScroll, { passive: true });
//       document.addEventListener('touchstart', handleTouchStart, { passive: true });
//       document.addEventListener('touchmove', handleTouchMove, { passive: true });
      
//       return () => {
//         window.removeEventListener('scroll', handleScroll);
//         document.removeEventListener('touchstart', handleTouchStart);
//         document.removeEventListener('touchmove', handleTouchMove);
//       };
//     }
//   }, [isMobileSearchOpen]);

//   // Load saved location and check cart items
//   useEffect(() => {
//     try {
//       // Load saved location
//       const savedLocation = localStorage.getItem('userLocation');
//       if (savedLocation) {
//         try {
//           const parsedLocation = JSON.parse(savedLocation);
//           setCurrentLocation(parsedLocation.formattedAddress || parsedLocation.address);
//           setFullAddress(parsedLocation);
//         } catch (error) {
//           console.error("Error parsing saved location:", error);
//         }
//       }
      
//       // Load cart items
//       const cartItems = localStorage.getItem('cartItems');
//       if (cartItems) {
//         try {
//           const parsedCart = JSON.parse(cartItems);
//           const totalItems = Array.isArray(parsedCart) 
//             ? parsedCart.reduce((total, item) => total + (item.quantity || 1), 0)
//             : 0;
//           setCartCount(totalItems);
//         } catch (error) {
//           console.error("Error parsing cart items:", error);
//         }
//       }
//     } catch (error) {
//       console.error("Error accessing localStorage:", error);
//     }
//   }, []);

//   // Add event listener for cart updates
//   useEffect(() => {
//     const handleCartUpdate = () => {
//       try {
//         const cartItems = localStorage.getItem('cartItems');
//         if (cartItems) {
//           const parsedCart = JSON.parse(cartItems);
//           const totalItems = Array.isArray(parsedCart) 
//             ? parsedCart.reduce((total, item) => total + (item.quantity || 1), 0)
//             : 0;
//           setCartCount(totalItems);
//         } else {
//           setCartCount(0);
//         }
//       } catch (error) {
//         console.error("Error accessing localStorage:", error);
//         setCartCount(0);
//       }
//     };

//     window.addEventListener('cartUpdated', handleCartUpdate);
    
//     return () => {
//       window.removeEventListener('cartUpdated', handleCartUpdate);
//     };
//   }, []);

//   // Click outside handler for dropdowns
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         categoriesRef.current && 
//         !categoriesRef.current.contains(event.target) &&
//         dropdownRef.current && 
//         !dropdownRef.current.contains(event.target)
//       ) {
//         setIsCategoriesDropdownOpen(false);
//       }
      
//       if (locationRef.current && !locationRef.current.contains(event.target)) {
//         setIsLocationDropdownOpen(false);
//       }
      
//       // Close profile dropdown when clicking outside
//       if (profileRef.current && !profileRef.current.contains(event.target)) {
//         setIsProfileDropdownOpen(false);
//       }
      
//       // Close mobile profile dropdown when clicking outside
//       if (
//         mobileProfileDropdownRef.current && 
//         !mobileProfileDropdownRef.current.contains(event.target) &&
//         !event.target.closest('.mobile-nav-item.profile') &&
//         mobileNavProfileRef.current !== event.target &&
//         !mobileNavProfileRef.current?.contains(event.target) &&
//         !event.target.classList.contains('profile-content-wrapper') &&
//         !event.target.closest('.profile-content-wrapper') &&
//         !event.target.classList.contains('profile-overlay')
//       ) {
//         setIsProfileDropdownOpen(false);
//       }
      
//       // Close search results when clicking outside
//       if (
//         searchResultsRef.current && 
//         !searchResultsRef.current.contains(event.target) &&
//         !event.target.closest('.search-input') &&
//         !event.target.closest('.mobile-search-input')
//       ) {
//         setShowSearchResults(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   // Geocoding function
//   const getDetailedAddressFromCoordinates = async (latitude, longitude) => {
//     try {
//       const response = await fetch(
//         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`
//       );

//       if (!response.ok) {
//         throw new Error('Google Geocoding API error');
//       }

//       const data = await response.json();

//       if (data.status !== 'OK' || !data.results || data.results.length === 0) {
//         throw new Error('No address found for this location');
//       }

//       const fullResult = data.results[0];
//       const formattedAddress = fullResult.formatted_address;
//       const displayAddress = formattedAddress.split(',').slice(0, 3).join(',');

//       return {
//         fullAddress: formattedAddress,
//         formattedAddress: displayAddress,
//         latitude,
//         longitude
//       };
//     } catch (googleError) {
//       console.error("Error with Google Geocoding:", googleError);
//       try {
//         const response = await fetch(
//           `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
//         );

//         if (!response.ok) {
//           throw new Error('Geocoding API error');
//         }

//         const data = await response.json();
//         const area = data.locality || data.principalSubdivision || '';
//         const city = data.city || data.locality || 'Bengaluru';
//         const formattedAddress = `${area}, ${city}`;

//         return {
//           area,
//           city,
//           formattedAddress,
//           latitude,
//           longitude
//         };
//       } catch (fallbackError) {
//         console.error("Error in fallback geocoding:", fallbackError);
//         throw new Error('Could not determine your location. Please select manually.');
//       }
//     }
//   };

//   // Location handlers
//   const handleUseCurrentLocation = () => {
//     if (navigator.geolocation) {
//       setIsLocating(true);
//       setLocationError('');

//       navigator.geolocation.getCurrentPosition(
//         async (position) => {
//           try {
//             const { latitude, longitude } = position.coords;
//             const addressData = await getDetailedAddressFromCoordinates(latitude, longitude);

//             setCurrentLocation(addressData.formattedAddress);
//             setFullAddress(addressData);
//             try {
//               localStorage.setItem('userLocation', JSON.stringify(addressData));
//             } catch (error) {
//               console.error("Error saving to localStorage:", error);
//             }
//             setIsLocationDropdownOpen(false);
//             setIsLocating(false);
//           } catch (error) {
//             console.error("Error getting detailed address:", error);
//             setLocationError(error.message);
//             setIsLocating(false);
//           }
//         },
//         (error) => {
//           console.error("Geolocation error:", error);
//           let errorMessage = 'Unable to detect location';

//           if (error.code === 1) {
//             errorMessage = 'Location access denied. Please enable location services.';
//           } else if (error.code === 2) {
//             errorMessage = 'Location unavailable. Please try again later.';
//           } else if (error.code === 3) {
//             errorMessage = 'Location request timed out. Please try again.';
//           }

//           setLocationError(errorMessage);
//           setIsLocating(false);
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 10000,
//           maximumAge: 0
//         }
//       );
//     } else {
//       setLocationError('Geolocation is not supported by your browser');
//     }
//   };

//   const handleLocationSelect = (location) => {
//     setCurrentLocation(location);
//     setFullAddress({ formattedAddress: location });
//     setIsLocationDropdownOpen(false);
    
//     try {
//       localStorage.setItem('userLocation', JSON.stringify({
//         formattedAddress: location
//       }));
//     } catch (error) {
//       console.error("Error saving to localStorage:", error);
//     }
//   };

//   // Navigation handlers
//   const handleLogoClick = () => {
//     navigate('/');
//     window.scrollTo(0, 0); // Add scroll to top here
//     setActiveMobileTab('home');
//   };

//   // Modified mobile tab click handler to use browser history for search
//   // UPDATED: Added window.scrollTo(0, 0) to each navigation case
//   const handleMobileTabClick = (tabName, event) => {
//     if (event) {
//       event.preventDefault();
//       event.stopPropagation();
//     }
    
//     setActiveMobileTab(tabName);
    
//     switch(tabName) {
//       case 'home':
//         navigate('/');
//         window.scrollTo(0, 0); // Add scroll to top
//         break;
//       case 'categories':
//         navigate('/products');
//         window.scrollTo(0, 0); // Add scroll to top
//         break;
//       case 'search':
//         setIsMobileSearchOpen(true);
//         // Add a history entry when opening search overlay
//         window.history.pushState({ mobileSearch: true }, '');
//         // Reset scroll position when opening search
//         window.scrollTo(0, 0);
//         break;
//       case 'cart':
//         navigate('/cart');
//         window.scrollTo(0, 0); // Add scroll to top
//         break;
//       case 'profile':
//         if (isLoggedIn) {
//           // FIXED: Directly navigate to profile page first, then show dropdown
//           navigate('/profile');
//           window.scrollTo(0, 0); // Add scroll to top
//           // Only after navigation, toggle the dropdown
//           setTimeout(() => {
//             setIsProfileDropdownOpen(true);
//           }, 100);
//         } else {
//           navigate('/login');
//           window.scrollTo(0, 0); // Add scroll to top
//         }
//         break;
//       default:
//         break;
//     }
//   };

//   // Search for products in Firestore
//   const searchProducts = async (query) => {
//     if (!query.trim()) {
//       setShowSearchResults(false);
//       setNoResultsFound(false);
//       return;
//     }
    
//     try {
//       // Convert query to lowercase for case-insensitive search
//       const searchTerm = query.toLowerCase().trim();
      
//       // Normalize search term (remove extra spaces, etc.)
//       const normalizedSearchTerm = searchTerm.replace(/\s+/g, ' ');
      
//       // Also try with different word arrangements
//       const searchWords = normalizedSearchTerm.split(' ');
//       const alternateSearchTerms = [];
      
//       // Add variations of the search term
//       if (searchWords.length > 1) {
//         // Try different word orders
//         const permutations = [];
//         function generatePermutations(arr, start = 0) {
//           if (start === arr.length - 1) {
//             permutations.push([...arr]);
//             return;
//           }
//           for (let i = start; i < arr.length; i++) {
//             [arr[start], arr[i]] = [arr[i], arr[start]]; // Swap
//             generatePermutations(arr, start + 1);
//             [arr[start], arr[i]] = [arr[i], arr[start]]; // Restore
//           }
//         }
//         generatePermutations(searchWords);
        
//         permutations.forEach(perm => {
//           alternateSearchTerms.push(perm.join(' '));
//         });
        
//         // Also try with and without plural forms
//         alternateSearchTerms.push(
//           normalizedSearchTerm.endsWith('s') ? normalizedSearchTerm.slice(0, -1) : normalizedSearchTerm + 's'
//         );
//       }
      
//       // Check if search term matches any category (first priority)
//       const matchingCategories = categories.filter(category => 
//         category.toLowerCase().includes(normalizedSearchTerm)
//       );
      
//       // If searching for a general term like "components", check all categories
//       const isGeneralSearch = normalizedSearchTerm.includes('component') || 
//                              normalizedSearchTerm.includes('sensor') || 
//                              normalizedSearchTerm.includes('module') ||
//                              normalizedSearchTerm.includes('arduino') ||
//                              normalizedSearchTerm.includes('board') ||
//                              normalizedSearchTerm.includes('wire') ||
//                              normalizedSearchTerm.includes('jumper') ||
//                              normalizedSearchTerm === 'tools';
      
//       // Query products collection
//       const productsRef = collection(db, 'products');
//       const productsSnapshot = await getDocs(productsRef);
      
//       if (productsSnapshot.empty) {
//         setSearchResults([]);
//         setNoResultsFound(true);
//         setShowSearchResults(true);
//         return;
//       }
      
//       // Get all products
//       const allProducts = productsSnapshot.docs.map(doc => ({ 
//         id: doc.id, 
//         ...doc.data() 
//       }));
      
//       // Debug - log the products and search term
//       console.log("All products:", allProducts.map(p => p.name));
//       console.log("Searching for:", normalizedSearchTerm, "Alternatives:", alternateSearchTerms);
      
//       // Filter products based on the search term and matching categories
//       let filteredProducts = allProducts.filter(product => {
//         // Normalize product data for better matching
//         const productName = (product.name || '').toLowerCase();
//         const productDesc = (product.description || '').toLowerCase();
//         const productCategory = (product.category || '').toLowerCase();
//         const productTags = Array.isArray(product.tags) 
//           ? product.tags.map(tag => tag.toLowerCase())
//           : [];
        
//         // Direct match in product name, description, or tags
//         const nameExactMatch = productName === normalizedSearchTerm;
//         const nameMatch = productName.includes(normalizedSearchTerm);
//         const descMatch = productDesc.includes(normalizedSearchTerm);
//         const tagMatch = productTags.some(tag => tag.includes(normalizedSearchTerm));
        
//         // Check for matches with alternate search terms
//         const alternateMatch = alternateSearchTerms.some(term => 
//           productName.includes(term) || 
//           productDesc.includes(term) || 
//           productTags.some(tag => tag.includes(term))
//         );
        
//         // Word-by-word matching (for cases like "jumper wires" vs "wires jumper")
//         const wordByWordMatch = searchWords.length > 1 && 
//           searchWords.every(word => 
//             productName.includes(word) || 
//             productDesc.includes(word) || 
//             productTags.some(tag => tag.includes(word))
//           );
        
//         // Check if product belongs to one of the matching categories
//         const categoryMatch = matchingCategories.length > 0 && 
//           matchingCategories.some(cat => 
//             productCategory === cat.toLowerCase() || 
//             productCategory.includes(cat.toLowerCase())
//           );
        
//         // For general searches like "components", include products from all relevant categories
//         const generalCategoryMatch = isGeneralSearch && productCategory;
        
//         // Debug specific products
//         if (productName.includes('jumper') || productName.includes('wire')) {
//           console.log("Found product with jumper/wire:", productName, {
//             nameExactMatch, nameMatch, descMatch, tagMatch, alternateMatch, wordByWordMatch
//           });
//         }
        
//         return nameExactMatch || nameMatch || descMatch || tagMatch || alternateMatch || 
//                wordByWordMatch || categoryMatch || generalCategoryMatch;
//       });
      
//       // Sort results - prioritize name matches, then category matches
//       filteredProducts.sort((a, b) => {
//         const aNameExactMatch = (a.name || '').toLowerCase() === normalizedSearchTerm ? 100 : 0;
//         const bNameExactMatch = (b.name || '').toLowerCase() === normalizedSearchTerm ? 100 : 0;
        
//         const aNameMatch = (a.name || '').toLowerCase().includes(normalizedSearchTerm) ? 50 : 0;
//         const bNameMatch = (b.name || '').toLowerCase().includes(normalizedSearchTerm) ? 50 : 0;
        
//         const aWordMatch = searchWords.filter(word => 
//           (a.name || '').toLowerCase().includes(word)
//         ).length;
        
//         const bWordMatch = searchWords.filter(word => 
//           (b.name || '').toLowerCase().includes(word)
//         ).length;
        
//         // Sort by exact match, then by partial match, then by word count match
//         if (aNameExactMatch !== bNameExactMatch) return bNameExactMatch - aNameExactMatch;
//         if (aNameMatch !== bNameMatch) return bNameMatch - aNameMatch;
//         if (aWordMatch !== bWordMatch) return bWordMatch - aWordMatch;
        
//         return (a.name || '').localeCompare(b.name || '');
//       });
      
//       // Limit results for dropdown
//       filteredProducts = filteredProducts.slice(0, 6);
      
//       console.log("Filtered products:", filteredProducts.map(p => p.name));
      
//       if (filteredProducts.length === 0) {
//         setNoResultsFound(true);
//       } else {
//         setSearchResults(filteredProducts);
//         setNoResultsFound(false);
//       }
      
//       setShowSearchResults(true);
//     } catch (error) {
//       console.error("Error searching products:", error);
//       setSearchResults([]);
//       setNoResultsFound(true);
//       setShowSearchResults(true);
//     }
//   };

//   // Effect for throttling search input
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (searchQuery.trim()) {
//         searchProducts(searchQuery);
//       }
//     }, 300); // Delay search by 300ms to avoid excessive queries
    
//     return () => clearTimeout(timer);
//   }, [searchQuery]);
  
//   const handleSearchInputChange = (e) => {
//     const value = e.target.value;
//     setSearchQuery(value);
    
//     if (!value.trim()) {
//       setShowSearchResults(false);
//       setNoResultsFound(false);
//     }
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     if (searchQuery.trim()) {
//       // Always navigate to products page, with different parameters based on results
//       if (noResultsFound) {
//         // Navigate to products page with the notFound parameter
//         // This will allow the products page to show the contact message
//         navigate(`/products?notFound=true&query=${encodeURIComponent(searchQuery)}`);
//       } else {
//         // If search term matches a category, navigate to that category
//         const searchTermLower = searchQuery.toLowerCase();
//         const matchingCategory = categories.find(category => 
//           category.toLowerCase() === searchTermLower || 
//           category.toLowerCase().includes(searchTermLower)
//         );
        
//         if (matchingCategory) {
//           navigate(`/products?category=${encodeURIComponent(matchingCategory.toLowerCase())}`);
//         } else {
//           navigate(`/products?search=${encodeURIComponent(searchQuery)}`);
//         }
//       }
      
//       window.scrollTo(0, 0); // Add scroll to top when submitting search
//       setSearchQuery('');
//       setShowSearchResults(false);
//       setIsMobileSearchOpen(false);
//     }
//   };

//   const handleProductSelect = (productId) => {
//     // Updated to use /products/:id format which is likely the correct route pattern
//     // This matches the plural format used in other routes like /products?category=...
//     navigate(`/products/${productId}`);
//     window.scrollTo(0, 0); // Add scroll to top when selecting a product
//     setSearchQuery('');
//     setShowSearchResults(false);
//     setIsMobileSearchOpen(false);
//   };

//   const handleCategorySelect = (category) => {
//     setSearchQuery(category);
//     setIsCategoriesDropdownOpen(false);
//     navigate(`/products?category=${encodeURIComponent(category.toLowerCase())}`);
//     window.scrollTo(0, 0); // Add scroll to top when selecting a category
//   };

//   // Handle logout
//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
      
//       // Clear localStorage data
//       localStorage.removeItem('userData');
//       localStorage.removeItem('authToken');
      
//       // Dispatch logout event for App.js to handle
//       window.dispatchEvent(new Event('userLoggedOut'));
      
//       setIsProfileDropdownOpen(false);
//       setIsLoggedIn(false);
//       setUserData(null);
      
//       navigate('/login');
//       window.scrollTo(0, 0); // Add scroll to top on logout
//     } catch (error) {
//       console.error("Error during logout:", error);
//     }
//   };

//   // Profile menu handlers
//   const toggleProfileDropdown = () => {
//     setIsProfileDropdownOpen(!isProfileDropdownOpen);
//   };

//   const handleProfileClick = () => {
//     setIsProfileDropdownOpen(false);
//     navigate('/profile');
//     window.scrollTo(0, 0); // Add scroll to top
//   };

//   const handleOrdersClick = () => {
//     setIsProfileDropdownOpen(false);
//     navigate('/orders');
//     window.scrollTo(0, 0); // Add scroll to top
//   };

//   const handleWishlistClick = () => {
//     setIsProfileDropdownOpen(false);
//     navigate('/wishlist');
//     window.scrollTo(0, 0); // Add scroll to top
//   };
  
//   // Close mobile profile dropdown
//   const handleCloseMobileProfile = (e) => {
//     e.stopPropagation();
//     setIsProfileDropdownOpen(false);
//   };

//   // UPDATED: Protection for profile-related pages, only redirect if not still loading auth
//   const shouldRedirectToLogin = (path) => {
//     if (isAuthLoading) return false; // Don't redirect while still checking auth
//     if (isLoggedIn) return false; // Don't redirect if logged in
    
//     // Check if this is a protected path
//     const protectedPaths = ['/profile', '/orders', '/wishlist'];
//     return protectedPaths.some(protectedPath => path.includes(protectedPath));
//   };

//   // If on a protected page and not logged in, redirect to login
//   // But only after auth check is complete
//   useEffect(() => {
//     if (initialAuthCheckRef.current && shouldRedirectToLogin(location.pathname)) {
//       navigate('/login');
//     }
//   }, [isAuthLoading, isLoggedIn, location.pathname, navigate]);

//   return (
//     <>
//       <header className="procart-header">
//         <div className="header-container">
//           {/* Logo Section - Always visible */}
//           <div className="logo-section">
//             <img 
//               src="/images/prologo.png" 
//               alt="ProCart India" 
//               className="logo"
//               onClick={handleLogoClick}
//             />
//           </div>

//           {/* Location Section - Always visible */}
//           <div className="location-section" ref={locationRef}>
//             <div 
//               className="location-selector"
//               onClick={() => setIsLocationDropdownOpen(!isLocationDropdownOpen)}
//               title={fullAddress?.fullAddress || currentLocation}
//             >
//               <div className="location-icon">
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
//                 </svg>
//               </div>
//               <div className="location-text">
//                 <span className="location-label">Deliver to</span>
//                 <span className="location-value">{currentLocation}</span>
//               </div>
//               <div className="dropdown-arrow">
//                 <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M7 10l5 5 5-5z"/>
//                 </svg>
//               </div>
//             </div>
            
//             {isLocationDropdownOpen && (
//               <div className="location-dropdown enhanced">
//                 <h4 className="location-popup-title">Browse your delivery location</h4>

//                 <button
//                   className="use-current-location"
//                   onClick={handleUseCurrentLocation}
//                   disabled={isLocating}
//                 >
//                   {isLocating ? (
//                     <>
//                       <div className="spinner"></div>
//                       <span>Detecting location...</span>
//                     </>
//                   ) : (
//                     <>
//                       <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//                         <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
//                       </svg>
//                       <span>Use current location</span>
//                     </>
//                   )}
//                 </button>

//                 {locationError && (
//                   <div className="location-error">
//                     {locationError}
//                   </div>
//                 )}

//                 {/* <div className="predefined-locations">
//                   <h5>Or select from popular locations:</h5>
//                   {predefinedLocations.map((location, index) => (
//                     <div 
//                       key={index}
//                       className="location-item"
//                       onClick={() => handleLocationSelect(location)}
//                     >
//                       <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
//                         <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
//                       </svg>
//                       {location}
//                     </div>
//                   ))}
//                 </div> */}
//               </div>
//             )}
//           </div>

//           {/* Desktop-only sections - Hidden in mobile responsive mode */}
//           {!isMobile && (
//             <>
//               {/* Search Section - Desktop only */}
//               <div className="search-section desktop-search">
//                 <form className="search-container" onSubmit={handleSearchSubmit}>
//                   <input
//                     type="text"
//                     placeholder="Search for Arduino, sensors, components..."
//                     className="search-input"
//                     value={searchQuery}
//                     onChange={handleSearchInputChange}
//                   />
//                   <button type="submit" className="search-button">
//                     <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                       <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
//                     </svg>
//                   </button>
//                 </form>
                
//                 {/* Search Results Dropdown */}
//                 {showSearchResults && (
//                   <div className="search-results-dropdown" ref={searchResultsRef}>
//                     {noResultsFound ? (
//                       <div className="no-results-message">
//                         <p>if you couldn't find any items in our store.</p>
//                         <div className="contact-info1">
//                           <p>Contact our team directly to get this component or model:</p>
//                           <div className="contact-number1">
//                             <span>8861938913</span>
//                           </div>
//                         </div>
//                         <button 
//                           className="search-contact-button"
//                           onClick={() => handleSearchSubmit({ preventDefault: () => {} })}
//                         >
//                           View All Components
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="search-results-list">
//                         {searchResults.map(product => (
//                           <div 
//                             key={product.id}
//                             className="search-result-item"
//                             onClick={() => handleProductSelect(product.id)}
//                           >
//                             <div className="search-result-image">
//                               {product.imageUrl ? (
//                                 <img src={product.imageUrl} alt={product.name} />
//                               ) : (
//                                 <div className="placeholder-image">
//                                   <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
//                                     <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"/>
//                                   </svg>
//                                 </div>
//                               )}
//                             </div>
//                             <div className="search-result-details">
//                               <h4>{product.name}</h4>
//                               <p className="search-result-price">
//                                 ₹{product.salePrice || product.price || 0}
//                               </p>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* Categories Section - Desktop only */}
//               <div className="categories-section desktop-nav">
//                 <div 
//                   ref={categoriesRef}
//                   className="categories-button"
//                   onClick={() => setIsCategoriesDropdownOpen(!isCategoriesDropdownOpen)}
//                 >
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//                     <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/>
//                   </svg>
//                   <span>Categories</span>
//                   <svg 
//                     width="12" 
//                     height="12" 
//                     viewBox="0 0 24 24" 
//                     fill="currentColor"
//                     style={{ 
//                       transform: isCategoriesDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//                       transition: 'transform 0.2s ease'
//                     }}
//                   >
//                     <path d="M7 10l5 5 5-5z"/>
//                   </svg>
//                 </div>
                
//                 {isCategoriesDropdownOpen && (
//                   <div ref={dropdownRef} className="categories-dropdown">
//                     {isLoadingCategories ? (
//                       <div className="loading-categories">
//                         <div className="spinner-small"></div>
//                         <span>Loading categories...</span>
//                       </div>
//                     ) : categories.length > 0 ? (
//                       categories.map((category, index) => (
//                         <div 
//                           key={index}
//                           className="category-item"
//                           onClick={() => handleCategorySelect(category)}
//                         >
//                           {category}
//                         </div>
//                       ))
//                     ) : (
//                       <div className="no-categories">
//                         <span>No categories found</span>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* Cart Section - Desktop only */}
//               <div className="cart-section desktop-nav">
//                 <button className="cart-button" onClick={() => handleMobileTabClick('cart')}>
//                   <div className="cart-icon-container">
//                     <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
//                       <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
//                     </svg>
//                     {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
//                   </div>
//                   <span className="cart-text">Cart</span>
//                 </button>
//               </div>

//               {/* User Profile Section - Desktop only */}
//               <div className="login-section desktop-nav" ref={profileRef}>
//                 {isAuthLoading ? (
//                   <div className="auth-loading-indicator">
//                     <div className="auth-spinner"></div>
//                     <span>Loading...</span>
//                   </div>
//                 ) : isLoggedIn && userData ? (
//                   <div className="profile-dropdown-container">
//                     <button className="profile-button" onClick={toggleProfileDropdown}>
//                       <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                         <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
//                       </svg>
//                       <span>{userData.name || 'User'}</span>
//                       <svg 
//                         width="12" 
//                         height="12" 
//                         viewBox="0 0 24 24" 
//                         fill="currentColor"
//                         style={{ 
//                           transform: isProfileDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//                           transition: 'transform 0.2s ease'
//                         }}
//                       >
//                         <path d="M7 10l5 5 5-5z"/>
//                       </svg>
//                     </button>
                    
//                     {isProfileDropdownOpen && (
//                       <div className="profile-dropdown">
//                         <div className="profile-header">
//                           <div className="welcome-message">
//                             <h4>Welcome, {userData.name || 'User'}</h4>
//                             <p>{userData.email || ''}</p>
//                           </div>
//                         </div>
//                         <div className="profile-options">
//                           <div className="profile-option" onClick={handleProfileClick}>
//                             <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                               <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
//                             </svg>
//                             <span>My Profile</span>
//                           </div>
//                           <div className="profile-option" onClick={handleOrdersClick}>
//                             <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                               <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/>
//                             </svg>
//                             <span>My Orders</span>
//                           </div>
                         
//                           <div className="profile-option" onClick={handleWishlistClick}>
//                             <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                               <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
//                             </svg>
//                             <span>My Wishlist</span>
//                           </div>
//                         </div>
//                         <div className="profile-footer">
//                           <button className="logout-button" onClick={handleLogout}>
//                             <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                               <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
//                             </svg>
//                             <span>Log Out</span>
//                           </button>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ) : (
//                   <button className="login-button" onClick={() => navigate('/login')}>
//                     <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                       <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
//                     </svg>
//                     <span>Login</span>
//                   </button>
//                 )}
//               </div>
//             </>
//           )}
//         </div>
//       </header>

//       {/* Mobile Search Overlay - MODIFIED to remove back button */}
//       {isMobileSearchOpen && (
//         <div 
//           className="mobile-search-overlay active"
//           id="mobile-search-overlay"
//         >
//           <div className="mobile-search-container">
//             <form className="mobile-search-form" onSubmit={handleSearchSubmit}>
//               {/* Back button removed - using native back functionality instead */}
//               <input
//                 type="text"
//                 placeholder="Search for components..."
//                 value={searchQuery}
//                 onChange={handleSearchInputChange}
//                 autoFocus
//                 className="mobile-search-input"
//               />
//               <button type="submit" className="mobile-search-submit">
//                 <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
//                 </svg>
//               </button>
//             </form>
            
//             {/* Mobile Search Results */}
//             {showSearchResults && (
//               <div className="mobile-search-results">
//                 {noResultsFound ? (
//                   <div className="mobile-no-results-message">
//                     <p>We couldn't find "{searchQuery}" in our store.</p>
//                     <div className="mobile-contact-info">
//                       <p>Contact our team directly to get this component or model:</p>
//                       <div className="mobile-contact-number">
//                         <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//                           <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
//                         </svg>
//                         <span>9606271260</span>
//                       </div>
//                     </div>
//                     <button 
//                       className="search-contact-button"
//                       onClick={() => handleSearchSubmit({ preventDefault: () => {} })}
//                     >
//                       View All Components
//                     </button>
//                   </div>
//                 ) : (
//                   <div className="mobile-search-results-list">
//                     {searchResults.map(product => (
//                       <div 
//                         key={product.id}
//                         className="mobile-search-result-item"
//                         onClick={() => handleProductSelect(product.id)}
//                       >
//                         <div className="mobile-search-result-image">
//                           {product.imageUrl ? (
//                             <img src={product.imageUrl} alt={product.name} />
//                           ) : (
//                             <div className="mobile-placeholder-image">
//                               <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
//                                 <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"/>
//                               </svg>
//                             </div>
//                           )}
//                         </div>
//                         <div className="mobile-search-result-details">
//                           <h4>{product.name}</h4>
//                           <p className="mobile-search-result-price">
//                             ₹{product.salePrice || product.price || 0}
//                           </p>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Mobile Profile Dropdown */}
//       {isMobile && isLoggedIn && isProfileDropdownOpen && (
//         <div className="mobile-profile-dropdown" ref={mobileProfileDropdownRef}>
//           <div className="mobile-profile-header">
//             <div className="welcome-message">
//               <h4>Welcome, {userData?.name || 'User'}</h4>
//               <p>{userData?.email || ''}</p>
//             </div>
//             <button className="close-profile-btn" onClick={handleCloseMobileProfile}>
//               <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
//               </svg>
//             </button>
//           </div>
//           <div className="profile-options">
//             <div className="profile-option" onClick={handleProfileClick}>
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
//               </svg>
//               <span>My Profile</span>
//             </div>
//             <div className="profile-option" onClick={handleOrdersClick}>
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/>
//               </svg>
//               <span>My Orders</span>
//             </div>
//             <div className="profile-option" onClick={handleWishlistClick}>
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
//               </svg>
//               <span>My Wishlist</span>
//             </div>
//           </div>
//           <div className="profile-footer">
//             <button className="logout-button" onClick={handleLogout}>
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
//               </svg>
//               <span>Log Out</span>
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Mobile Bottom Navigation - Show in responsive mode */}
//       {isMobile && (
//         <div className="mobile-bottom-nav">
//           <button 
//             className={`mobile-nav-item ${activeMobileTab === 'home' ? 'active' : ''}`}
//             onClick={(e) => handleMobileTabClick('home', e)}
//           >
//             <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="mobile-nav-icon">
//               <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
//             </svg>
//             <span className="mobile-nav-text">Home</span>
//           </button>
          
//           <button 
//             className={`mobile-nav-item ${activeMobileTab === 'categories' ? 'active' : ''}`}
//             onClick={(e) => handleMobileTabClick('categories', e)}
//           >
//             <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="mobile-nav-icon">
//               <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/>
//             </svg>
//             <span className="mobile-nav-text">Categories</span>
//           </button>
          
//           <button 
//             className={`mobile-nav-item ${activeMobileTab === 'search' ? 'active' : ''}`}
//             onClick={(e) => handleMobileTabClick('search', e)}
//           >
//             <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="mobile-nav-icon">
//               <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
//             </svg>
//             <span className="mobile-nav-text">Search</span>
//           </button>
          
//           <button 
//             className={`mobile-nav-item ${activeMobileTab === 'cart' ? 'active' : ''}`}
//             onClick={(e) => handleMobileTabClick('cart', e)}
//           >
//             <div className="mobile-cart-container">
//               <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="mobile-nav-icon">
//                 <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
//               </svg>
//               {cartCount > 0 && <span className="mobile-cart-count">{cartCount}</span>}
//             </div>
//             <span className="mobile-nav-text">Cart</span>
//           </button>
          
//           {/* Improved profile button with better click handling */}
//           <button 
//             className={`mobile-nav-item ${activeMobileTab === 'profile' ? 'active' : ''} profile`}
//             onClick={(e) => handleMobileTabClick('profile', e)}
//             ref={mobileNavProfileRef}
//           >
//             <div className="profile-content-wrapper">
//               <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="mobile-nav-icon">
//                 <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
//               </svg>
//               <span className="mobile-nav-text">{isLoggedIn ? 'Profile' : 'Login'}</span>
//             </div>
//             {/* Add a transparent overlay to improve touch capture */}
//             <div 
//               className="profile-overlay" 
//               onClick={(e) => handleMobileTabClick('profile', e)}
//             />
//           </button>
//         </div>
//       )}
//     </>
//   );
// };

// export default Header;




import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { db } from '../../firebase/firebaseConfig'; 
import './Header.css';

// Replace with your Google Maps API key
const GOOGLE_MAPS_API_KEY = 'AIzaSyA5ReIwel6soo1uIWWRvAIdIubZQKnbjfc';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Add this to get current route
  const auth = getAuth();
  
  // State management
  const [isLocationDropdownOpen, setIsLocationDropdownOpen] = useState(false);
  const [isCategoriesDropdownOpen, setIsCategoriesDropdownOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [currentLocation, setCurrentLocation] = useState('Select Location');
  const [fullAddress, setFullAddress] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [cartCount, setCartCount] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLocating, setIsLocating] = useState(false);
  const [locationError, setLocationError] = useState('');
  const [activeMobileTab, setActiveMobileTab] = useState('home');
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAuthLoading, setIsAuthLoading] = useState(true); // Add loading state for auth
  const [userData, setUserData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(true);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [noResultsFound, setNoResultsFound] = useState(false);
  const [allProducts, setAllProducts] = useState([]); // New state to store all products
  
  // Refs for handling events
  const categoriesRef = useRef(null);
  const dropdownRef = useRef(null);
  const locationRef = useRef(null);
  const profileRef = useRef(null);
  const mobileProfileDropdownRef = useRef(null);
  const searchResultsRef = useRef(null);
  const mobileNavProfileRef = useRef(null);
  const initialAuthCheckRef = useRef(false); // Ref to track initial auth check

  // Check if we're in mobile responsive mode
  const isMobile = windowWidth <= 1142;

  const predefinedLocations = [
    'Bengaluru, Karnataka',
    'Mumbai, Maharashtra', 
    'Delhi, NCR',
    'Chennai, Tamil Nadu',
    'Hyderabad, Telangana',
    'Pune, Maharashtra',
    'Kolkata, West Bengal'
  ];

  // Add CSS styles for improving touch interactions
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .mobile-nav-item.profile {
        -webkit-tap-highlight-color: transparent;
        touch-action: manipulation;
        cursor: pointer;
        position: relative;
      }
      .mobile-nav-item.profile * {
        pointer-events: none;
      }
      .profile-content-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .mobile-profile-dropdown {
        z-index: 1000;
      }
      .profile-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }
      .mobile-search-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        animation: slideInFromBottom 0.2s ease-out;
      }
      @keyframes slideInFromBottom {
        0% {
          transform: translateY(20px);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
      @keyframes slideOutToBottom {
        0% {
          transform: translateY(0);
          opacity: 1;
        }
        100% {
          transform: translateY(20px);
          opacity: 0;
        }
      }
      .mobile-search-overlay.closing {
        animation: slideOutToBottom 0.2s ease-out;
        animation-fill-mode: forwards;
      }
      /* Updated mobile search form styles without back button */
      .mobile-search-form {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        background-color: #f5f5f5;
        border-bottom: 1px solid #e0e0e0;
      }
      .mobile-search-input {
        flex: 1;
        height: 42px;
        padding: 8px 12px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        font-size: 16px;
        background-color: #fff;
      }
      .mobile-search-submit {
        background: none;
        border: none;
        padding: 8px;
        margin-left: 8px;
        color: #333;
        cursor: pointer;
      }
      /* Add a simple spinner for loading states */
      .auth-spinner {
        width: 20px;
        height: 20px;
        border: 2px solid rgba(0, 0, 0, 0.1);
        border-top-color: #333;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
        margin-right: 8px;
        display: inline-block;
      }
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Check auth state using Firebase Auth - UPDATED to handle loading state and ensure redirection
  useEffect(() => {
    setIsAuthLoading(true); // Start with loading state
    
    // Try to get cached auth data from localStorage
    try {
      const cachedAuthData = localStorage.getItem('userData');
      const authToken = localStorage.getItem('authToken');
      
      if (cachedAuthData && authToken) {
        try {
          const parsedData = JSON.parse(cachedAuthData);
          // Temporarily set user data while waiting for Firebase
          setUserData(parsedData);
          setIsLoggedIn(true);
          
          // If we're on the login page, redirect to profile
          if (location.pathname.includes('/login')) {
            navigate('/profile');
          }
        } catch (parseError) {
          console.error("Error parsing cached auth data:", parseError);
          localStorage.removeItem('userData');
          localStorage.removeItem('authToken');
        }
      }
    } catch (error) {
      console.error("Error accessing localStorage cache:", error);
    }
    
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // Get user data from Firestore
        const fetchUserData = async () => {
          try {
            const userDocRef = query(
              collection(db, 'users'),
              where('uid', '==', user.uid)
            );
            const userSnapshot = await getDocs(userDocRef);
            
            if (!userSnapshot.empty) {
              const userData = userSnapshot.docs[0].data();
              const userDataWithDefaults = { 
                uid: user.uid,
                name: userData.name || user.displayName || 'User',
                email: userData.email || user.email,
                phone: userData.phone || '',
                ...userData
              };
              
              setUserData(userDataWithDefaults);
              
              // Store in localStorage for persistence
              try {
                localStorage.setItem('userData', JSON.stringify(userDataWithDefaults));
                localStorage.setItem('authToken', 'true'); // Simple presence flag
              } catch (error) {
                console.error("Error saving to localStorage:", error);
              }
            } else {
              const basicUserData = {
                uid: user.uid,
                name: user.displayName || 'User',
                email: user.email
              };
              
              setUserData(basicUserData);
              
              // Store in localStorage for persistence
              try {
                localStorage.setItem('userData', JSON.stringify(basicUserData));
                localStorage.setItem('authToken', 'true');
              } catch (error) {
                console.error("Error saving to localStorage:", error);
              }
            }
            
            setIsLoggedIn(true);
            
            // IMPORTANT: If we're on the login page, immediately redirect to profile
            if (location.pathname.includes('/login')) {
              navigate('/profile');
            }
          } catch (error) {
            console.error("Error fetching user data:", error);
            const fallbackData = {
              uid: user.uid,
              name: user.displayName || 'User',
              email: user.email
            };
            
            setUserData(fallbackData);
            setIsLoggedIn(true);
            
            try {
              localStorage.setItem('userData', JSON.stringify(fallbackData));
              localStorage.setItem('authToken', 'true');
            } catch (storageError) {
              console.error("Error saving to localStorage:", storageError);
            }
            
            // Even with errors, if authenticated, redirect from login page
            if (location.pathname.includes('/login')) {
              navigate('/profile');
            }
          } finally {
            setIsAuthLoading(false); // Auth loading complete
            initialAuthCheckRef.current = true;
          }
        };
        
        fetchUserData();
      } else {
        setIsLoggedIn(false);
        setUserData(null);
        
        // Clear localStorage data when logged out
        try {
          localStorage.removeItem('userData');
          localStorage.removeItem('authToken');
        } catch (error) {
          console.error("Error accessing localStorage:", error);
        }
        
        setIsAuthLoading(false); // Auth loading complete
        initialAuthCheckRef.current = true;
        
        // Only redirect to login if not in the process of logging in
        // This prevents redirecting during page refresh when auth is still initializing
        if (initialAuthCheckRef.current && 
            !location.pathname.includes('/login') && 
            !location.pathname.includes('/register') &&
            (location.pathname.includes('/profile') || 
             location.pathname.includes('/orders') || 
             location.pathname.includes('/wishlist'))) {
          navigate('/login');
        }
      }
    });
    
    return () => unsubscribe();
  }, [auth, navigate, location.pathname]);

  // Listen for login/logout events
  useEffect(() => {
    const handleLoginEvent = () => {
      // Auth state will handle this, but we can also force a data refresh
      const cachedAuthData = localStorage.getItem('userData');
      if (cachedAuthData) {
        try {
          const parsedData = JSON.parse(cachedAuthData);
          setUserData(parsedData);
          setIsLoggedIn(true);
        } catch (error) {
          console.error("Error parsing userData from event:", error);
        }
      }
    };
    
    const handleLogoutEvent = () => {
      setIsProfileDropdownOpen(false);
      setIsLoggedIn(false);
      setUserData(null);
    };
    
    window.addEventListener('userLoggedIn', handleLoginEvent);
    window.addEventListener('userLoggedOut', handleLogoutEvent);
    
    return () => {
      window.removeEventListener('userLoggedIn', handleLoginEvent);
      window.removeEventListener('userLoggedOut', handleLogoutEvent);
    };
  }, []);

  // Set active tab based on current path
  useEffect(() => {
    const currentPath = location.pathname;
    
    if (currentPath === '/' || currentPath === '/home') {
      setActiveMobileTab('home');
    } else if (currentPath.includes('/products')) {
      setActiveMobileTab('categories');
    } else if (currentPath.includes('/cart')) {
      setActiveMobileTab('cart');
    } else if (currentPath.includes('/profile') || 
               currentPath.includes('/login') || 
               currentPath.includes('/orders') ||
               currentPath.includes('/wishlist')) {
      setActiveMobileTab('profile');
    } else {
      setActiveMobileTab('home');
    }
  }, [location]);

  // UPDATED: Fetch categories from Firestore with proper sorting by creation date
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setIsLoadingCategories(true);
        
        // First get all active categories without sorting (to avoid index requirements)
        const categoriesQuery = query(
          collection(db, 'categories'),
          where('active', '==', true)
        );
        
        const categoriesSnapshot = await getDocs(categoriesQuery);
        
        if (!categoriesSnapshot.empty) {
          // Get full category data including createdAt timestamps
          const categoriesData = categoriesSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          
          // Sort categories by createdAt timestamp (newest first)
          categoriesData.sort((a, b) => {
            // Handle missing createdAt values
            if (!a.createdAt) return 1;
            if (!b.createdAt) return -1;
            // Sort in descending order (newest first)
            return b.createdAt - a.createdAt;
          });
          
          // Extract just the category names for the dropdown
          const categoryNames = categoriesData.map(cat => cat.name);
          setCategories(categoryNames);
        } else {
          console.log('No categories found in Firestore');
          setCategories([]);
        }
      } catch (error) {
        console.error('Error fetching categories from Firestore:', error);
        // Fallback to default categories if there's an error
        setCategories([
          'Microcontrollers',
          'Single Board Computers',
          'Sensors',
          'Actuators',
          'Motor Controllers',
          'Power Components',
          'Communication Modules',
          'Interface Components',
          'Mechanical Components',
          'Tools and Accessories'
        ]);
      } finally {
        setIsLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  // NEW: Fetch all products for improved search
  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        // Fetch from products collection
        const productsQuery = query(collection(db, 'products'));
        const productsSnapshot = await getDocs(productsQuery);
        
        let productsList = [];
        
        if (!productsSnapshot.empty) {
          productsList = productsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
        }
        
        // Also fetch from categoryItems collection to ensure we get all products
        const categoryItemsQuery = query(collection(db, 'categoryItems'));
        const categoryItemsSnapshot = await getDocs(categoryItemsQuery);
        
        if (!categoryItemsSnapshot.empty) {
          const categoryItems = categoryItemsSnapshot.docs.map(doc => {
            const data = doc.data();
            return {
              id: doc.id,
              name: data.name || 'Untitled Item',
              price: data.price || 0,
              originalPrice: data.originalPrice || data.price || 0,
              discountPercentage: data.discountPercentage || 0,
              description: data.description || '',
              category: data.categoryName || '',
              tags: data.tags || [],
              imageUrl: data.imageUrl || '',
              active: data.active !== false, // Default to true if not specified
              ...data
            };
          });
          
          // Merge the two product sets, avoiding duplicates by ID
          const existingIds = new Set(productsList.map(p => p.id));
          const uniqueCategoryItems = categoryItems.filter(item => !existingIds.has(item.id));
          
          productsList = [...productsList, ...uniqueCategoryItems];
        }
        
        // Filter out inactive products
        productsList = productsList.filter(product => product.active !== false);
        
        setAllProducts(productsList);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    
    fetchAllProducts();
  }, []);

  // Add resize handler
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      
      // Add padding to body when mobile nav is shown
      if (width >= 340 && width <= 1142) {
        document.body.style.paddingBottom = '60px';
        document.documentElement.classList.add('mobile-viewport');
      } else {
        document.body.style.paddingBottom = '0';
        document.documentElement.classList.remove('mobile-viewport');
      }
    };

    // Set initial values immediately
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.style.paddingBottom = '0';
      document.documentElement.classList.remove('mobile-viewport');
    };
  }, []);

  // Add touch event handler specifically for mobile profile button
  useEffect(() => {
    const handleProfileButtonInteraction = (e) => {
      if (isMobile && isLoggedIn) {
        e.preventDefault();
        navigate('/profile');
        window.scrollTo(0, 0); // Add scroll to top here
        setTimeout(() => {
          setIsProfileDropdownOpen(true);
        }, 100);
      }
    };

    // Add event listener to the profile button
    const profileButton = mobileNavProfileRef.current;
    if (profileButton) {
      profileButton.addEventListener('touchstart', handleProfileButtonInteraction, { passive: false });
    }

    return () => {
      if (profileButton) {
        profileButton.removeEventListener('touchstart', handleProfileButtonInteraction);
      }
    };
  }, [isMobile, isLoggedIn, navigate, mobileNavProfileRef]);
  
  // Close mobile search with animation
  const closeMobileSearch = () => {
    const overlay = document.getElementById('mobile-search-overlay');
    if (overlay) {
      overlay.classList.add('closing');
      setTimeout(() => {
        setIsMobileSearchOpen(false);
      }, 200); // Match animation duration
    } else {
      setIsMobileSearchOpen(false);
    }
  };

  // Handle browser back button for mobile search
  useEffect(() => {
    const handlePopState = (event) => {
      // If the search overlay is open, close it when back button is pressed
      if (isMobileSearchOpen) {
        closeMobileSearch();
      }
    };

    // Add event listener for the back button
    window.addEventListener('popstate', handlePopState);
    
    // Clean up the event listener when component unmounts
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isMobileSearchOpen]);

  // Add scroll handler to close mobile search when scrolling back
  useEffect(() => {
    let lastScrollY = window.scrollY;
    let touchStartY = 0;
    let scrollThreshold = 20; // minimum scroll distance to trigger close
    
    const handleScroll = () => {
      if (!isMobileSearchOpen) return;
      
      const currentScrollY = window.scrollY;
      const scrollDifference = currentScrollY - lastScrollY;
      
      // If scrolling up (negative difference) by more than threshold, close the search
      if (scrollDifference < -scrollThreshold) {
        closeMobileSearch();
      }
      
      lastScrollY = currentScrollY;
    };
    
    const handleTouchStart = (e) => {
      touchStartY = e.touches[0].clientY;
    };
    
    const handleTouchMove = (e) => {
      if (!isMobileSearchOpen) return;
      
      const currentY = e.touches[0].clientY;
      const diff = currentY - touchStartY;
      
      // If swiping down by more than threshold, close the search
      if (diff > scrollThreshold * 2) {
        closeMobileSearch();
      }
    };
    
    if (isMobileSearchOpen) {
      // Reset the last scroll position when opening the search
      lastScrollY = window.scrollY;
      
      // Add scroll event listener
      window.addEventListener('scroll', handleScroll, { passive: true });
      document.addEventListener('touchstart', handleTouchStart, { passive: true });
      document.addEventListener('touchmove', handleTouchMove, { passive: true });
      
      return () => {
        window.removeEventListener('scroll', handleScroll);
        document.removeEventListener('touchstart', handleTouchStart);
        document.removeEventListener('touchmove', handleTouchMove);
      };
    }
  }, [isMobileSearchOpen]);

  // Load saved location and check cart items
  useEffect(() => {
    try {
      // Load saved location
      const savedLocation = localStorage.getItem('userLocation');
      if (savedLocation) {
        try {
          const parsedLocation = JSON.parse(savedLocation);
          setCurrentLocation(parsedLocation.formattedAddress || parsedLocation.address);
          setFullAddress(parsedLocation);
        } catch (error) {
          console.error("Error parsing saved location:", error);
        }
      }
      
      // Load cart items
      const cartItems = localStorage.getItem('cartItems');
      if (cartItems) {
        try {
          const parsedCart = JSON.parse(cartItems);
          const totalItems = Array.isArray(parsedCart) 
            ? parsedCart.reduce((total, item) => total + (item.quantity || 1), 0)
            : 0;
          setCartCount(totalItems);
        } catch (error) {
          console.error("Error parsing cart items:", error);
        }
      }
    } catch (error) {
      console.error("Error accessing localStorage:", error);
    }
  }, []);

  // Add event listener for cart updates
  useEffect(() => {
    const handleCartUpdate = () => {
      try {
        const cartItems = localStorage.getItem('cartItems');
        if (cartItems) {
          const parsedCart = JSON.parse(cartItems);
          const totalItems = Array.isArray(parsedCart) 
            ? parsedCart.reduce((total, item) => total + (item.quantity || 1), 0)
            : 0;
          setCartCount(totalItems);
        } else {
          setCartCount(0);
        }
      } catch (error) {
        console.error("Error accessing localStorage:", error);
        setCartCount(0);
      }
    };

    window.addEventListener('cartUpdated', handleCartUpdate);
    
    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, []);

  // Click outside handler for dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        categoriesRef.current && 
        !categoriesRef.current.contains(event.target) &&
        dropdownRef.current && 
        !dropdownRef.current.contains(event.target)
      ) {
        setIsCategoriesDropdownOpen(false);
      }
      
      if (locationRef.current && !locationRef.current.contains(event.target)) {
        setIsLocationDropdownOpen(false);
      }
      
      // Close profile dropdown when clicking outside
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsProfileDropdownOpen(false);
      }
      
      // Close mobile profile dropdown when clicking outside
      if (
        mobileProfileDropdownRef.current && 
        !mobileProfileDropdownRef.current.contains(event.target) &&
        !event.target.closest('.mobile-nav-item.profile') &&
        mobileNavProfileRef.current !== event.target &&
        !mobileNavProfileRef.current?.contains(event.target) &&
        !event.target.classList.contains('profile-content-wrapper') &&
        !event.target.closest('.profile-content-wrapper') &&
        !event.target.classList.contains('profile-overlay')
      ) {
        setIsProfileDropdownOpen(false);
      }
      
      // Close search results when clicking outside
      if (
        searchResultsRef.current && 
        !searchResultsRef.current.contains(event.target) &&
        !event.target.closest('.search-input') &&
        !event.target.closest('.mobile-search-input')
      ) {
        setShowSearchResults(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Geocoding function
  const getDetailedAddressFromCoordinates = async (latitude, longitude) => {
    // Try OpenStreetMap Nominatim first (more reliable and detailed)
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`,
        {
          headers: {
            'User-Agent': 'ProCart-India-App'
          }
        }
      );

      if (!response.ok) {
        throw new Error('Nominatim API error');
      }

      const data = await response.json();
      
      if (data && data.display_name) {
        const formattedAddress = data.display_name;

        return {
          formattedAddress: formattedAddress,
          fullAddress: formattedAddress,
          latitude,
          longitude
        };
      }
      throw new Error('No address data from Nominatim');
    } catch (nominatimError) {
      console.warn("Nominatim geocoding failed, trying Google:", nominatimError);
      
      // Fallback to Google Geocoding
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`
        );

        if (!response.ok) {
          throw new Error('Google Geocoding API error');
        }

        const data = await response.json();

        if (data.status === 'OK' && data.results && data.results.length > 0) {
          const formattedAddress = data.results[0].formatted_address;

          return {
            fullAddress: formattedAddress,
            formattedAddress: formattedAddress,
            latitude,
            longitude
          };
        }
        throw new Error(`Google API Status: ${data.status}`);
      } catch (googleError) {
        console.error("Google Geocoding also failed:", googleError);
        throw new Error('Could not determine your location. Please select manually.');
      }
    }
  };

  // Location handlers
  const handleUseCurrentLocation = () => {
    if (navigator.geolocation) {
      setIsLocating(true);
      setLocationError('');

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords;
            const addressData = await getDetailedAddressFromCoordinates(latitude, longitude);

            setCurrentLocation(addressData.formattedAddress);
            setFullAddress(addressData);
            try {
              localStorage.setItem('userLocation', JSON.stringify(addressData));
            } catch (error) {
              console.error("Error saving to localStorage:", error);
            }
            setIsLocationDropdownOpen(false);
            setIsLocating(false);
          } catch (error) {
            console.error("Error getting detailed address:", error);
            setLocationError(error.message);
            setIsLocating(false);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          let errorMessage = 'Unable to detect location';

          if (error.code === 1) {
            errorMessage = 'Location access denied. Please enable location services.';
          } else if (error.code === 2) {
            errorMessage = 'Location unavailable. Please try again later.';
          } else if (error.code === 3) {
            errorMessage = 'Location request timed out. Please try again.';
          }

          setLocationError(errorMessage);
          setIsLocating(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    } else {
      setLocationError('Geolocation is not supported by your browser');
    }
  };

  const handleLocationSelect = (location) => {
    setCurrentLocation(location);
    setFullAddress({ formattedAddress: location });
    setIsLocationDropdownOpen(false);
    
    try {
      localStorage.setItem('userLocation', JSON.stringify({
        formattedAddress: location
      }));
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
  };

  // Navigation handlers
  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo(0, 0); // Add scroll to top here
    setActiveMobileTab('home');
  };

  // Modified mobile tab click handler to use browser history for search
  // UPDATED: Added window.scrollTo(0, 0) to each navigation case
  const handleMobileTabClick = (tabName, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    setActiveMobileTab(tabName);
    
    switch(tabName) {
      case 'home':
        navigate('/');
        window.scrollTo(0, 0); // Add scroll to top
        break;
      case 'categories':
        navigate('/products');
        window.scrollTo(0, 0); // Add scroll to top
        break;
      case 'search':
        setIsMobileSearchOpen(true);
        // Add a history entry when opening search overlay
        window.history.pushState({ mobileSearch: true }, '');
        // Reset scroll position when opening search
        window.scrollTo(0, 0);
        break;
      case 'cart':
        navigate('/cart');
        window.scrollTo(0, 0); // Add scroll to top
        break;
      case 'profile':
        if (isLoggedIn) {
          // FIXED: Directly navigate to profile page first, then show dropdown
          navigate('/profile');
          window.scrollTo(0, 0); // Add scroll to top
          // Only after navigation, toggle the dropdown
          setTimeout(() => {
            setIsProfileDropdownOpen(true);
          }, 100);
        } else {
          navigate('/login');
          window.scrollTo(0, 0); // Add scroll to top
        }
        break;
      default:
        break;
    }
  };

  // IMPROVED: Search for products with better category matching
  const searchProducts = async (query) => {
    if (!query.trim()) {
      setShowSearchResults(false);
      setNoResultsFound(false);
      return;
    }
    
    try {
      // Convert query to lowercase for case-insensitive search
      const searchTerm = query.toLowerCase().trim();
      
      // Normalize search term (remove extra spaces, etc.)
      const normalizedSearchTerm = searchTerm.replace(/\s+/g, ' ');
      
      // Split into individual words for more granular matching
      const searchWords = normalizedSearchTerm.split(' ');
      
      // Generate variations of the search term
      const alternateSearchTerms = [];
      
      // Add word variations
      if (searchWords.length > 1) {
        // Add different word orders
        for (let i = 0; i < searchWords.length; i++) {
          const rotated = [...searchWords.slice(i), ...searchWords.slice(0, i)];
          alternateSearchTerms.push(rotated.join(' '));
        }
        
        // Add singular/plural variations
        searchWords.forEach(word => {
          if (word.length > 3) {
            alternateSearchTerms.push(
              word.endsWith('s') ? word.slice(0, -1) : word + 's'
            );
          }
        });
      }
      
      // Match with categories (prioritize category matches)
      const matchingCategories = categories.filter(category => 
        category.toLowerCase().includes(normalizedSearchTerm) ||
        normalizedSearchTerm.includes(category.toLowerCase()) ||
        searchWords.some(word => category.toLowerCase().includes(word))
      );
      
      // Define general search terms that could match with many products
      const isGeneralSearch = ['component', 'sensor', 'module', 'arduino', 
                              'board', 'wire', 'jumper', 'tool', 'shield',
                              'raspberry', 'pi', 'led', 'motor', 'battery',
                              'power', 'micro', 'controller', 'kit', 'display'].some(term => 
        normalizedSearchTerm.includes(term)
      );
      
      // Use the pre-loaded products instead of fetching again
      const allProductsToSearch = allProducts;
      
      // Prepare scoring system for relevance
      const scoredProducts = allProductsToSearch.map(product => {
        // Normalize product data for matching
        const productName = (product.name || '').toLowerCase();
        const productDesc = (product.description || '').toLowerCase();
        const productCategory = (product.category || '').toLowerCase();
        const productTags = Array.isArray(product.tags) 
          ? product.tags.map(tag => tag.toLowerCase())
          : [];
        
        // Start with a score of 0
        let score = 0;
        
        // Exact match scoring
        if (productName === normalizedSearchTerm) score += 100;
        if (productName.includes(normalizedSearchTerm)) score += 50;
        if (productDesc.includes(normalizedSearchTerm)) score += 30;
        
        // Category match scoring
        if (matchingCategories.length > 0) {
          if (matchingCategories.some(cat => 
            productCategory === cat.toLowerCase() || 
            productCategory.includes(cat.toLowerCase())
          )) {
            score += 40;
          }
        }
        
        // Tag match scoring
        if (productTags.some(tag => tag.includes(normalizedSearchTerm))) {
          score += 40;
        }
        
        // Word-by-word matching
        const wordMatchCount = searchWords.filter(word => 
          productName.includes(word) || 
          productDesc.includes(word) || 
          productTags.some(tag => tag.includes(word))
        ).length;
        
        score += wordMatchCount * 10;
        
        // Alternate term matching
        if (alternateSearchTerms.some(term => 
          productName.includes(term) || 
          productDesc.includes(term) || 
          productTags.some(tag => tag.includes(term))
        )) {
          score += 25;
        }
        
        // General search bonus for category matches
        if (isGeneralSearch && 
            (productCategory.includes(normalizedSearchTerm) || 
             searchWords.some(word => productCategory.includes(word)))) {
          score += 20;
        }
        
        // Only include products with a positive score
        return { product, score };
      }).filter(item => item.score > 0);
      
      // Sort by score (highest first)
      scoredProducts.sort((a, b) => b.score - a.score);
      
      // Extract just the products
      const filteredProducts = scoredProducts.map(item => item.product);
      
      // Limit to top 6 results for display
      const topResults = filteredProducts.slice(0, 6);
      
      console.log("Search Results:", topResults.map(p => p.name));
      
      if (topResults.length === 0) {
        setNoResultsFound(true);
      } else {
        setSearchResults(topResults);
        setNoResultsFound(false);
      }
      
      setShowSearchResults(true);
    } catch (error) {
      console.error("Error searching products:", error);
      setSearchResults([]);
      setNoResultsFound(true);
      setShowSearchResults(true);
    }
  };

  // Effect for throttling search input
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery.trim()) {
        searchProducts(searchQuery);
      }
    }, 300); // Delay search by 300ms to avoid excessive queries
    
    return () => clearTimeout(timer);
  }, [searchQuery]);
  
  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    
    if (!value.trim()) {
      setShowSearchResults(false);
      setNoResultsFound(false);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Always navigate to products page, with different parameters based on results
      if (noResultsFound) {
        // Navigate to products page with the notFound parameter
        // This will allow the products page to show the contact message
        navigate(`/products?notFound=true&query=${encodeURIComponent(searchQuery)}`);
      } else {
        // If search term matches a category, navigate to that category
        const searchTermLower = searchQuery.toLowerCase();
        const matchingCategory = categories.find(category => 
          category.toLowerCase() === searchTermLower || 
          category.toLowerCase().includes(searchTermLower)
        );
        
        if (matchingCategory) {
          navigate(`/products?category=${encodeURIComponent(matchingCategory.toLowerCase())}`);
        } else {
          navigate(`/products?search=${encodeURIComponent(searchQuery)}`);
        }
      }
      
      window.scrollTo(0, 0); // Add scroll to top when submitting search
      setSearchQuery('');
      setShowSearchResults(false);
      setIsMobileSearchOpen(false);
    }
  };

  const handleProductSelect = (productId) => {
    // Updated to use /products/:id format which is likely the correct route pattern
    // This matches the plural format used in other routes like /products?category=...
    navigate(`/products/${productId}`);
    window.scrollTo(0, 0); // Add scroll to top when selecting a product
    setSearchQuery('');
    setShowSearchResults(false);
    setIsMobileSearchOpen(false);
  };

  const handleCategorySelect = (category) => {
    setSearchQuery(category);
    setIsCategoriesDropdownOpen(false);
    navigate(`/products?category=${encodeURIComponent(category.toLowerCase())}`);
    window.scrollTo(0, 0); // Add scroll to top when selecting a category
  };

  // Handle logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      
      // Clear localStorage data
      localStorage.removeItem('userData');
      localStorage.removeItem('authToken');
      
      // Dispatch logout event for App.js to handle
      window.dispatchEvent(new Event('userLoggedOut'));
      
      setIsProfileDropdownOpen(false);
      setIsLoggedIn(false);
      setUserData(null);
      
      navigate('/login');
      window.scrollTo(0, 0); // Add scroll to top on logout
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  // Profile menu handlers
  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
  };

  const handleProfileClick = () => {
    setIsProfileDropdownOpen(false);
    navigate('/profile');
    window.scrollTo(0, 0); // Add scroll to top
  };

  const handleOrdersClick = () => {
    setIsProfileDropdownOpen(false);
    navigate('/orders');
    window.scrollTo(0, 0); // Add scroll to top
  };

  const handleWishlistClick = () => {
    setIsProfileDropdownOpen(false);
    navigate('/wishlist');
    window.scrollTo(0, 0); // Add scroll to top
  };
  
  // Close mobile profile dropdown
  const handleCloseMobileProfile = (e) => {
    e.stopPropagation();
    setIsProfileDropdownOpen(false);
  };

  // UPDATED: Protection for profile-related pages, only redirect if not still loading auth
  const shouldRedirectToLogin = (path) => {
    if (isAuthLoading) return false; // Don't redirect while still checking auth
    if (isLoggedIn) return false; // Don't redirect if logged in
    
    // Check if this is a protected path
    const protectedPaths = ['/profile', '/orders', '/wishlist'];
    return protectedPaths.some(protectedPath => path.includes(protectedPath));
  };

  // If on a protected page and not logged in, redirect to login
  // But only after auth check is complete
  useEffect(() => {
    if (initialAuthCheckRef.current && shouldRedirectToLogin(location.pathname)) {
      navigate('/login');
    }
  }, [isAuthLoading, isLoggedIn, location.pathname, navigate]);

  return (
    <>
      <header className="procart-header">
        <div className="header-container">
          {/* Logo Section - Always visible */}
          <div className="logo-section">
            <img 
              src="/images/Procart_Logo.jpg" 
              alt="ProCart India" 
              className="logo"
              onClick={handleLogoClick}
            />
          </div>

          {/* Location Section - Always visible */}
          <div className="location-section" ref={locationRef}>
            <div 
              className="location-selector"
              onClick={() => setIsLocationDropdownOpen(!isLocationDropdownOpen)}
              title={fullAddress?.fullAddress || currentLocation}
            >
              <div className="location-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
              </div>
              <div className="location-text">
                <span className="location-label">Deliver to</span>
                <span className="location-value">{currentLocation}</span>
              </div>
              <div className="dropdown-arrow">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 10l5 5 5-5z"/>
                </svg>
              </div>
            </div>
            
            {isLocationDropdownOpen && (
              <div className="location-dropdown enhanced">
                <h4 className="location-popup-title">Browse your delivery location</h4>

                <button
                  className="use-current-location"
                  onClick={handleUseCurrentLocation}
                  disabled={isLocating}
                >
                  {isLocating ? (
                    <>
                      <div className="spinner"></div>
                      <span>Detecting location...</span>
                    </>
                  ) : (
                    <>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
                      </svg>
                      <span>Use current location</span>
                    </>
                  )}
                </button>

                {locationError && (
                  <div className="location-error">
                    {locationError}
                  </div>
                )}

                {/* <div className="predefined-locations">
                  <h5>Or select from popular locations:</h5>
                  {predefinedLocations.map((location, index) => (
                    <div 
                      key={index}
                      className="location-item"
                      onClick={() => handleLocationSelect(location)}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                      </svg>
                      {location}
                    </div>
                  ))}
                </div> */}
              </div>
            )}
          </div>

          {/* Desktop-only sections - Hidden in mobile responsive mode */}
          {!isMobile && (
            <>
              {/* Search Section - Desktop only */}
              <div className="search-section desktop-search">
                <form className="search-container" onSubmit={handleSearchSubmit}>
                  <input
                    type="text"
                    placeholder="Search for Arduino, sensors, components..."
                    className="search-input"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                  />
                  <button type="submit" className="search-button">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                    </svg>
                  </button>
                </form>
                
                {/* Search Results Dropdown */}
                {showSearchResults && (
                  <div className="search-results-dropdown" ref={searchResultsRef}>
                    {noResultsFound ? (
                      <div className="no-results-message">
                        <p>We couldn't find any items matching "{searchQuery}" in our store.</p>
                        <div className="contact-info1">
                          <p>Contact our team directly to get this component or model:</p>
                          <div className="contact-number1">
                            <span>8861938913</span>
                          </div>
                        </div>
                        <button 
                          className="search-contact-button"
                          onClick={() => handleSearchSubmit({ preventDefault: () => {} })}
                        >
                          View All Components
                        </button>
                      </div>
                    ) : (
                      <div className="search-results-list">
                        {searchResults.map(product => (
                          <div 
                            key={product.id}
                            className="search-result-item"
                            onClick={() => handleProductSelect(product.id)}
                          >
                            <div className="search-result-image">
                              {product.imageUrl ? (
                                <img src={product.imageUrl} alt={product.name} />
                              ) : (
                                <div className="placeholder-image">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"/>
                                  </svg>
                                </div>
                              )}
                            </div>
                            <div className="search-result-details">
                              <h4>{product.name}</h4>
                              <p className="search-result-price">
                                ₹{product.salePrice || product.price || 0}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Categories Section - Desktop only */}
              {/* <div className="categories-section desktop-nav">
                <div 
                  ref={categoriesRef}
                  className="categories-button"
                  onClick={() => setIsCategoriesDropdownOpen(!isCategoriesDropdownOpen)}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/>
                  </svg>
                  <span>Categories</span>
                  <svg 
                    width="12" 
                    height="12" 
                    viewBox="0 0 24 24" 
                    fill="currentColor"
                    style={{ 
                      transform: isCategoriesDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.2s ease'
                    }}
                  >
                    <path d="M7 10l5 5 5-5z"/>
                  </svg>
                </div>
                
                {isCategoriesDropdownOpen && (
                  <div ref={dropdownRef} className="categories-dropdown">
                    {isLoadingCategories ? (
                      <div className="loading-categories">
                        <div className="spinner-small"></div>
                        <span>Loading categories...</span>
                      </div>
                    ) : categories.length > 0 ? (
                      categories.map((category, index) => (
                        <div 
                          key={index}
                          className="category-item"
                          onClick={() => handleCategorySelect(category)}
                        >
                          {category}
                        </div>
                      ))
                    ) : (
                      <div className="no-categories">
                        <span>No categories found</span>
                      </div>
                    )}
                  </div>
                )}
              </div> */}

              {/* Cart Section - Desktop only */}
              <div className="cart-section desktop-nav">
                <button className="cart-button" onClick={() => handleMobileTabClick('cart')}>
                  <div className="cart-icon-container">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
                    </svg>
                    {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
                  </div>
                  <span className="cart-text">Cart</span>
                </button>
              </div>

              {/* User Profile Section - Desktop only */}
              <div className="login-section desktop-nav" ref={profileRef}>
                {isAuthLoading ? (
                  <div className="auth-loading-indicator">
                    <div className="auth-spinner"></div>
                    <span>Loading...</span>
                  </div>
                ) : isLoggedIn && userData ? (
                  <div className="profile-dropdown-container">
                    <button className="profile-button" onClick={toggleProfileDropdown}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                      </svg>
                      <span>{userData.name || 'User'}</span>
                      <svg 
                        width="12" 
                        height="12" 
                        viewBox="0 0 24 24" 
                        fill="currentColor"
                        style={{ 
                          transform: isProfileDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.2s ease'
                        }}
                      >
                        <path d="M7 10l5 5 5-5z"/>
                      </svg>
                    </button>
                    
                    {isProfileDropdownOpen && (
                      <div className="profile-dropdown">
                        <div className="profile-header">
                          <div className="welcome-message">
                            <h4>Welcome, {userData.name || 'User'}</h4>
                            <p>{userData.email || ''}</p>
                          </div>
                        </div>
                        <div className="profile-options">
                          <div className="profile-option" onClick={handleProfileClick}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                            </svg>
                            <span>My Profile</span>
                          </div>
                          <div className="profile-option" onClick={handleOrdersClick}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/>
                            </svg>
                            <span>My Orders</span>
                          </div>
                         
                          <div className="profile-option" onClick={handleWishlistClick}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                            </svg>
                            <span>My Wishlist</span>
                          </div>
                        </div>
                        <div className="profile-footer">
                          <button className="logout-button" onClick={handleLogout}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
                            </svg>
                            <span>Log Out</span>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <button className="login-button" onClick={() => navigate('/login')}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                      </svg>
                      <span>Login</span>
                    </button>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </header>

      {/* Mobile Search Overlay - MODIFIED to remove back button */}
      {isMobileSearchOpen && (
        <div 
          className="mobile-search-overlay active"
          id="mobile-search-overlay"
        >
          <div className="mobile-search-container">
            <form className="mobile-search-form" onSubmit={handleSearchSubmit}>
              {/* Back button removed - using native back functionality instead */}
              <input
                type="text"
                placeholder="Search for components..."
                value={searchQuery}
                onChange={handleSearchInputChange}
                autoFocus
                className="mobile-search-input"
              />
              <button type="submit" className="mobile-search-submit">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>
              </button>
            </form>
            
            {/* Mobile Search Results */}
            {showSearchResults && (
              <div className="mobile-search-results">
                {noResultsFound ? (
                  <div className="mobile-no-results-message">
                    <p>We couldn't find "{searchQuery}" in our store.</p>
                    <div className="mobile-contact-info">
                      <p>Contact our team directly to get this component or model:</p>
                      <div className="mobile-contact-number">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                        </svg>
                        <span>9606271260</span>
                      </div>
                    </div>
                    <button 
                      className="search-contact-button"
                      onClick={() => handleSearchSubmit({ preventDefault: () => {} })}
                    >
                      View All Components
                    </button>
                  </div>
                ) : (
                  <div className="mobile-search-results-list">
                    {searchResults.map(product => (
                      <div 
                        key={product.id}
                        className="mobile-search-result-item"
                        onClick={() => handleProductSelect(product.id)}
                      >
                        <div className="mobile-search-result-image">
                          {product.imageUrl ? (
                            <img src={product.imageUrl} alt={product.name} />
                          ) : (
                            <div className="mobile-placeholder-image">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"/>
                              </svg>
                            </div>
                          )}
                        </div>
                        <div className="mobile-search-result-details">
                          <h4>{product.name}</h4>
                          <p className="mobile-search-result-price">
                            ₹{product.salePrice || product.price || 0}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Mobile Profile Dropdown */}
      {isMobile && isLoggedIn && isProfileDropdownOpen && (
        <div className="mobile-profile-dropdown" ref={mobileProfileDropdownRef}>
          <div className="mobile-profile-header">
            <div className="welcome-message">
              <h4>Welcome, {userData?.name || 'User'}</h4>
              <p>{userData?.email || ''}</p>
            </div>
            <button className="close-profile-btn" onClick={handleCloseMobileProfile}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
          </div>
          <div className="profile-options">
            <div className="profile-option" onClick={handleProfileClick}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
              <span>My Profile</span>
            </div>
            <div className="profile-option" onClick={handleOrdersClick}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/>
              </svg>
              <span>My Orders</span>
            </div>
            <div className="profile-option" onClick={handleWishlistClick}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
              <span>My Wishlist</span>
            </div>
          </div>
          <div className="profile-footer">
            <button className="logout-button" onClick={handleLogout}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
              </svg>
              <span>Log Out</span>
            </button>
          </div>
        </div>
      )}

      {/* Mobile Bottom Navigation - Show in responsive mode */}
      {isMobile && (
        <div className="mobile-bottom-nav">
          <button 
            className={`mobile-nav-item ${activeMobileTab === 'categories' ? 'active' : ''}`}
            onClick={(e) => handleMobileTabClick('categories', e)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="mobile-nav-icon">
              <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/>
            </svg>
            <span className="mobile-nav-text">Categories</span>
          </button>
          
          <button 
            className={`mobile-nav-item ${activeMobileTab === 'search' ? 'active' : ''}`}
            onClick={(e) => handleMobileTabClick('search', e)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="mobile-nav-icon">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            <span className="mobile-nav-text">Search</span>
          </button>
          
          <button 
            className={`mobile-nav-item ${activeMobileTab === 'cart' ? 'active' : ''}`}
            onClick={(e) => handleMobileTabClick('cart', e)}
          >
            <div className="mobile-cart-container">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="mobile-nav-icon">
                <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
              </svg>
              {cartCount > 0 && <span className="mobile-cart-count">{cartCount}</span>}
            </div>
            <span className="mobile-nav-text">Cart</span>
          </button>
          
          {/* Improved profile button with better click handling */}
          <button 
            className={`mobile-nav-item ${activeMobileTab === 'profile' ? 'active' : ''} profile`}
            onClick={(e) => handleMobileTabClick('profile', e)}
            ref={mobileNavProfileRef}
          >
            <div className="profile-content-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="mobile-nav-icon">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
              <span className="mobile-nav-text">{isLoggedIn ? 'Profile' : 'Login'}</span>
            </div>
            {/* Add a transparent overlay to improve touch capture */}
            <div 
              className="profile-overlay" 
              onClick={(e) => handleMobileTabClick('profile', e)}
            />
          </button>
        </div>
      )}
    </>
  );
};

export default Header;